import React from 'react';

export default function SearchBar({
  searchWrapperRef,
  searchQuery,
  setSearchQuery,
  searchResults,
  isSearchFocused,
  setIsSearchFocused,
  handleSearchResultClick,
}) {
  return (
    <div ref={searchWrapperRef} className="relative max-w-2xl mx-auto mb-8">
      <input
        type="search"
        placeholder="Search for a service or practitioner..."
        className="w-full p-3 pl-10 text-lg text-black bg-white bg-opacity-90 rounded-full shadow-lg focus:outline-none focus:ring-2 focus:ring-teal-400"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        onFocus={() => setIsSearchFocused(true)}
        autoComplete="off"
      />
      <div className="absolute top-0 left-0 flex items-center h-full pl-3">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
      </div>
      {isSearchFocused && searchResults.length > 0 && (
        <div className="absolute top-full mt-2 w-full bg-white text-black rounded-lg shadow-xl overflow-hidden z-50">
          <ul>
            {searchResults.map((result, index) => (
              <li
                key={index}
                className="px-4 py-3 cursor-pointer hover:bg-gray-100 border-b last:border-b-0"
                onClick={() => handleSearchResultClick(result)}
              >
                <span className="font-semibold">{result.name}</span>
                <span className={`ml-2 text-xs font-bold py-0.5 px-2 rounded-full ${result.type === 'Service' ? 'bg-blue-200 text-blue-800' : 'bg-green-200 text-green-800'}`}>
                  {result.type}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
